import React, { useState } from "react";
import dayjs from "dayjs";
import { DecreaseArrowIcon, IncreaseArrowIcon } from "./Icons";
import "dayjs/locale/hi"
const GOLD_COLUMNS = [
    { key: "date", label: "तारीख", align: "text-left" },
    { key: "carat24", label: "24 कैरेट" },
    { key: "carat22", label: "22 कैरेट" },
    { key: "carat18", label: "18 कैरेट" },
];

const SILVER_COLUMNS = [
    { key: "date", label: "तारीख", align: "text-left" },
    { key: "oneGram", label: "1 ग्राम" },
    { key: "tenGram", label: "10 ग्राम" },
    { key: "hundredGram", label: "100 ग्राम" },
    { key: "oneKg", label: "1000 ग्राम" },
];

const TABS = [
    { key: "thirtyDaysHistory", label: "पिछले 30 दिनों का", days: 30 },
    { key: "threeMonthsHistory", label: "पिछले 3 महीनों का", days: 90 },
    { key: "sixMonthsHistory", label: "पिछले 6 महीनों का", days: 180 },
    { key: "oneYearHistory", label: "पिछले 1 साल का", days: null },
];

function formatDate(dateStr) {
    const today = dayjs().format("YYYY-MM-DD");
    const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");
    const label = dayjs(dateStr).format("DD MMM");
    const label_hn = dayjs(dateStr)
        .locale("hi")
        .format("DD MMMM")

    if (dateStr?.includes(today)) { return <span className="font-bold">आज</span> }
    if (dateStr?.includes(yesterday)) {

        return <><span className="font-bold">{label_hn}</span></>;
    }


    return <><span className="font-bold">{label}</span> ({label_hn})</>;
}

function formatPrice(value) {
    if (value == null) return "-";
    return `₹${Number(value).toLocaleString("en-IN")}`;
}

function getCellTrend(allRates, index, key) {
    const current = allRates[index]?.[key];
    const previous = allRates[index + 1]?.[key];
    if (current == null || previous == null) return null;
    const diff = current - previous;
    return { diff, isUp: diff > 0 };
}

function bgClassToCss(cls, fallback = "#ffffff") {
    if (!cls) return fallback;
    const match = cls.match(/^bg-\[#([0-9a-fA-F]{3,8})\](?:\/(\d{1,3}))?$/);
    if (!match) return fallback;
    let hex = match[1];
    let alpha = match[2] != null ? Number(match[2]) / 100 : 1;
    if (hex.length === 3) hex = hex.split("").map((c) => c + c).join("");
    if (hex.length === 8) {
        alpha = parseInt(hex.slice(6, 8), 16) / 255;
        hex = hex.slice(0, 6);
    }
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

function extractHex(cls, fallback) {
    if (!cls) return fallback;
    const match = cls.match(/#([0-9a-fA-F]{3,8})/);
    if (!match) return fallback;
    let hex = match[1];
    if (hex.length === 3) hex = hex.split("").map((c) => c + c).join("");
    return `#${hex.slice(0, 6)}`;
}

function stickyFillStyle(tintColor, extraShadow, borderColor) {
    const shadows = [extraShadow, `inset 0 0 0 0 ${borderColor}`, `inset 0 0 0 9999px ${tintColor}`].filter(Boolean);
    return {
        backgroundColor: "#ffffff",
        boxShadow: shadows.join(", "),
        transform: "translateZ(0)",
    };
}

export const TabsTable = ({ data, type = "gold", colors = {} }) => {
    const [activeTab, setActiveTab] = useState(TABS[0].key);
    const [hoveredRow, setHoveredRow] = useState(null);
    const columns = type === "gold" ? GOLD_COLUMNS : SILVER_COLUMNS;
    const allRates = data?.oneYearHistory?.rates ?? [];
    const activeTabConfig = TABS.find((tab) => tab.key === activeTab);
    const rates = activeTabConfig?.days ? allRates?.slice(0, activeTabConfig.days) : allRates;


    return (
        <div>
            {/* Tabs */}
            <div className="flex flex-wrap gap-2 p-2">
                {TABS.map((tab) => {
                    const isActive = tab.key === activeTab;
                    return (
                        <button
                            key={tab.key}
                            type="button"
                            onClick={() => setActiveTab(tab.key)}
                            className={`px-4 py-2 rounded-full text-xs md:text-sm font-semibold border transition-colors ${isActive
                                ? `${colors.gradient}`
                                : `${colors.lightBg}  font-semibold ${type === "gold" ? "border-[#edf069]" : "border-[#ececeb]"} hover:bg-gray-50`
                                }`}
                        >
                            {tab.label}
                        </button>
                    );
                })}
            </div>

            {/* Table */}
            <div
                className={`overflow-auto ${rates.length === 0 ? "h-auto" : "h-[380px]"}  `}
            // style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
            >
                <table className="w-full   text-sm border-b border-spacing-0">
                    <colgroup>
                        {columns.map((col) => (
                            <col key={col.key} style={{ width: col.key === "date" ? "140px" : `${100 / (columns.length - 1)}%` }} />
                        ))}
                    </colgroup>
                    <thead className={` ${colors.lightBg || "bg-[#fafafa]"}`}>
                        <tr>
                            {columns.map((col) =>
                                col.key === "date" ? (
                                    <th
                                        key={col.key}
                                        className="sticky top-0 left-0 z-30 px-6 right-0 py-2 text-xs md:text-sm font-semibold whitespace-nowrap text-left will-change-transform"
                                        style={{ ...stickyFillStyle(extractHex(colors.lightBgL, "#fafafa"), null, extractHex(colors.border, "#e5e7eb")), width: "140px" }}
                                    >
                                        {col.label}
                                    </th>
                                ) : (
                                    <th
                                        key={col.key}
                                        className={`sticky top-0 z-10 px-4 py-2 text-xs md:text-sm font-semibold border-b ${colors.border || "border-gray-200"} whitespace-nowrap`}
                                        style={{ backgroundColor: extractHex(colors.lightBgL, "#fafafa") }}
                                    >
                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 70px", alignItems: "center", columnGap: "6px" }}>
                                            <span className="text-right">{col.label}</span>
                                            <span />
                                        </div>
                                    </th>
                                )
                            )}
                        </tr>
                    </thead>

                    <tbody>
                        {rates.map((row, index) => (
                            <tr
                                key={index}
                                onMouseEnter={() => setHoveredRow(index)}
                                onMouseLeave={() => setHoveredRow(null)}
                                className={` ${index == 0 ? type === "gold" ? "bg-[#FFFDF5]" : "bg-[#F8F9FB99]" : ""}  border-b ${colors.border || "border-gray-200"} last:border-none hover:bg-gray-50`}
                            >
                                {columns.map((col) => {
                                    if (col.key === "date") {
                                        const rowTint = index === 0 ? (type === "gold" ? "bg-[#FFFDF5]" : "bg-[#F8F9FB99]") : "bg-white";
                                        const tintColor = hoveredRow === index ? "#f9fafb" : bgClassToCss(rowTint, "#ffffff");
                                        return (
                                            <td
                                                key="date"
                                                className="sticky left-0 z-10 px-4 py-3 whitespace-nowrap text-xs md:text-sm text-left font-medium will-change-transform"
                                                style={stickyFillStyle(tintColor, null, extractHex(colors.border, "#e5e7eb"))}
                                            >
                                                {formatDate(row.date, index)}
                                            </td>
                                        );
                                    }

                                    const cellTrend = getCellTrend(allRates, index, col.key);

                                    return (
                                        <td
                                            key={col.key}
                                            className="w-auto px-4 py-3 whitespace-nowrap text-xs md:text-sm"
                                        >
                                            <div style={{ display: "grid", gridTemplateColumns: "1fr 70px", alignItems: "center", columnGap: "6px" }}>
                                                <span className="text-right">{formatPrice(row[col.key])}</span>
                                                {cellTrend && (
                                                    <span
                                                        className={`inline-flex items-center justify-center gap-0.5 rounded-full px-1.5 py-0.5 text-[11px] font-semibold justify-self-start ${cellTrend.diff === 0
                                                            ? (type === "silver" ? "bg-gray-200 text-black" : "bg-yellow-100 text-black")
                                                            : cellTrend.isUp
                                                                ? "bg-green-100 text-green-600"
                                                                : "bg-red-100 text-red-600"
                                                            }`}
                                                        style={{ minWidth: "64px" }}
                                                    >
                                                        {cellTrend.diff === 0 ? null : cellTrend.isUp ? <IncreaseArrowIcon /> : <DecreaseArrowIcon />}
                                                        {cellTrend.isUp ? "+" : "-"}₹{Math.abs(cellTrend.diff)}
                                                    </span>
                                                )}
                                            </div>
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}

                        {rates.length === 0 && (
                            <tr>
                                <td
                                    colSpan={columns.length}
                                    className="px-4 py-6 text-center text-sm  "
                                >
                                    कोई डेटा उपलब्ध नहीं है
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>


        </div>
    );
};
